import { Box, Chip } from '@mui/material';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../core/hooks';
import { getL3ServiceStatusColor, L3ServiceViewModel } from '../../../l3-services/model';

interface Props {
  l3Service: L3ServiceViewModel;
}

export const L3ServiceStatusBadge: FunctionComponent<Props> = ({ l3Service }) => {
  const translate = useAppTranslate();
  const status = l3Service.status;
  const serviceStatusTranslationKey = `status.${status}`;
  const serviceStatusColor = getL3ServiceStatusColor(status);

  return <Box>{translate('markerPopup.serviceStatus')}: <Chip
    label={translate(serviceStatusTranslationKey)}
    sx={{
      height: 20,
      color: serviceStatusColor.color,
      background: serviceStatusColor.background,
    }}
  /></Box>;
};